import React from 'react';
import type { StatsCardProps } from '@/types/ui.types';

export const StatsCard: React.FC<StatsCardProps> = ({
	title,
	value,
	icon: Icon,
	color,
	trend,
	progress,
	className = '',
	onClick,
}) => {
	const colorClasses = {
		blue: {
			bg: 'bg-blue-100',
			hoverBg: 'group-hover:bg-blue-200',
			icon: 'text-blue-600',
			progress: 'bg-blue-500',
		},
		green: {
			bg: 'bg-green-100',
			hoverBg: 'group-hover:bg-green-200',
			icon: 'text-green-600',
			progress: 'bg-green-500',
		},
		purple: {
			bg: 'bg-purple-100',
			hoverBg: 'group-hover:bg-purple-200',
			icon: 'text-purple-600',
			progress: 'bg-purple-500',
		},
		orange: {
			bg: 'bg-orange-100',
			hoverBg: 'group-hover:bg-orange-200',
			icon: 'text-orange-600',
			progress: 'bg-orange-500',
		},
	};

	const colors = colorClasses[color];

	return (
		<div
			className={`bg-white rounded-xl shadow-sm border hover:shadow-lg transition-all duration-300 cursor-pointer group p-6 ${className}`}
			onClick={onClick}
		>
			<div className='flex items-center justify-between'>
				<div className='flex-1'>
					<p className='text-sm font-medium text-gray-500 mb-1'>{title}</p>
					<p className='text-2xl font-bold text-gray-900'>{value}</p>

					{/* Trend Indicator */}
					{trend && (
						<div className='flex items-center mt-2'>
							<span
								className={`text-sm font-medium ${
									trend.isPositive ? 'text-green-600' : 'text-red-600'
								}`}
							>
								{trend.isPositive ? '+' : ''}
								{trend.value}%
							</span>
							<span className='text-sm text-gray-500 ml-1'>{trend.label}</span>
						</div>
					)}
				</div>

				{/* Icon Container */}
				<div
					className={`w-16 h-16 ${colors.bg} rounded-full flex items-center justify-center ${colors.hoverBg} transition-colors`}
				>
					<Icon className={`w-8 h-8 ${colors.icon}`} />
				</div>
			</div>

			{/* Progress Bar */}
			{progress !== undefined && (
				<div className='mt-4'>
					<div className='w-full bg-gray-200 rounded-full h-2'>
						<div
							className={`${colors.progress} h-2 rounded-full transition-all duration-300`}
							style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
